const provinces = [
    { value: "", label: "-None-" },
    { value: "Agrigento (AG)", label: "Agrigento (AG)" },
    { value: "Alessandria (AL)", label: "Alessandria (AL)" },
    { value: "Ancona (AN)", label: "Ancona (AN)" },
    { value: "Aosta (AO)", label: "Aosta (AO)" },
    { value: "L'Aquila (AQ)", label: "L'Aquila (AQ)" },
    { value: "Arezzo (AR)", label: "Arezzo (AR)" },
    { value: "Ascoli-Piceno (AP)", label: "Ascoli-Piceno (AP)" },
    { value: "Asti (AT)", label: "Asti (AT)" },
    { value: "Avellino (AV)", label: "Avellino (AV)" },
    { value: "Bari (BA)", label: "Bari (BA)" },
    { value: "Barletta-Andria-Trani (BT)", label: "Barletta-Andria-Trani (BT)" },
    { value: "Belluno (BL)", label: "Belluno (BL)" },
    { value: "Benevento (BN)", label: "Benevento (BN)" },
    { value: "Bergamo (BG)", label: "Bergamo (BG)" },
    { value: "Biella (BI)", label: "Biella (BI)" },
    { value: "Bologna (BO)", label: "Bologna (BO)" },
    { value: "Bolzano (BZ)", label: "Bolzano (BZ)" },
    { value: "Brescia (BS)", label: "Brescia (BS)" },
    { value: "Brindisi (BR)", label: "Brindisi (BR)" },
    { value: "Cagliari (CA)", label: "Cagliari (CA)" },
    { value: "Caltanissetta (CL)", label: "Caltanissetta (CL)" },
    { value: "Campobasso (CB)", label: "Campobasso (CB)" },
    { value: "Carbonia Iglesias (CI)", label: "Carbonia Iglesias (CI)" },
    { value: "Caserta (CE)", label: "Caserta (CE)" },
    { value: "Catania (CT)", label: "Catania (CT)" },
    { value: "Catanzaro (CZ)", label: "Catanzaro (CZ)" },
    { value: "Chieti (CH)", label: "Chieti (CH)" },
    { value: "Como (CO)", label: "Como (CO)" },
    { value: "Cosenza (CS)", label: "Cosenza (CS)" },
    { value: "Cremona (CR)", label: "Cremona (CR)" },
    { value: "Crotone (KR)", label: "Crotone (KR)" },
    { value: "Cuneo (CN)", label: "Cuneo (CN)" },
    { value: "Enna (EN)", label: "Enna (EN)" },
    { value: "Fermo (FM)", label: "Fermo (FM)" },
    { value: "Ferrara (FE)", label: "Ferrara (FE)" },
    { value: "Firenze (FI)", label: "Firenze (FI)" },
    { value: "Foggia (FG)", label: "Foggia (FG)" },
    { value: "Forlì-Cesena (FC)", label: "Forlì-Cesena (FC)" },
    { value: "Frosinone (FR)", label: "Frosinone (FR)" },
    { value: "Genova (GE)", label: "Genova (GE)" },
    { value: "Gorizia (GO)", label: "Gorizia (GO)" },
    { value: "Grosseto (GR)", label: "Grosseto (GR)" },
    { value: "Imperia (IM)", label: "Imperia (IM)" },
    { value: "Isernia (IS)", label: "Isernia (IS)" },
    { value: "La-Spezia (SP)", label: "La-Spezia (SP)" },
    { value: "Latina (LT)", label: "Latina (LT)" },
    { value: "Lecce (LE)", label: "Lecce (LE)" },
    { value: "Lecco (LC)", label: "Lecco (LC)" },
    { value: "Livorno (LI)", label: "Livorno (LI)" },
    { value: "Lodi (LO)", label: "Lodi (LO)" },
    { value: "Lucca (LU)", label: "Lucca (LU)" },
    { value: "Macerata (MC)", label: "Macerata (MC)" },
    { value: "Mantova (MN)", label: "Mantova (MN)" },
    { value: "Massa-Carrara (MS)", label: "Massa-Carrara (MS)" },
    { value: "Matera (MT)", label: "Matera (MT)" },
    { value: "Medio Campidano (VS)", label: "Medio Campidano (VS)" },
    { value: "Messina (ME)", label: "Messina (ME)" },
    { value: "Milano (MI)", label: "Milano (MI)" },
    { value: "Milano Est (MIEst)", label: "Milano Est (MIEst)" },
    { value: "Milano Ovest (MIOvest)", label: "Milano Ovest (MIOvest)" },
    { value: "Modena (MO)", label: "Modena (MO)" },
    { value: "Monza-Brianza (MB)", label: "Monza-Brianza (MB)" },
    { value: "Napoli (NA)", label: "Napoli (NA)" },
    { value: "Novara (NO)", label: "Novara (NO)" },
    { value: "Nuoro (NU)", label: "Nuoro (NU)" },
    { value: "Ogliastra (OG)", label: "Ogliastra (OG)" },
    { value: "Olbia Tempio (OT)", label: "Olbia Tempio (OT)" },
    { value: "Oristano (OR)", label: "Oristano (OR)" },
    { value: "Padova (PD)", label: "Padova (PD)" },
    { value: "Palermo (PA)", label: "Palermo (PA)" },
    { value: "Parma (PR)", label: "Parma (PR)" },
    { value: "Pavia (PV)", label: "Pavia (PV)" },
    { value: "Perugia (PG)", label: "Perugia (PG)" },
    { value: "Pesaro-Urbino (PU)", label: "Pesaro-Urbino (PU)" },
    { value: "Pescara (PE)", label: "Pescara (PE)" },
    { value: "Piacenza (PC)", label: "Piacenza (PC)" },
    { value: "Pisa (PI)", label: "Pisa (PI)" },
    { value: "Pistoia (PT)", label: "Pistoia (PT)" },
    { value: "Pordenone (PN)", label: "Pordenone (PN)" },
    { value: "Potenza (PZ)", label: "Potenza (PZ)" },
    { value: "Prato (PO)", label: "Prato (PO)" },
    { value: "Ragusa (RG)", label: "Ragusa (RG)" },
    { value: "Ravenna (RA)", label: "Ravenna (RA)" },
    { value: "Reggio-Calabria (RC)", label: "Reggio-Calabria (RC)" },
    { value: "Reggio-Emilia (RE)", label: "Reggio-Emilia (RE)" },
    { value: "Rieti (RI)", label: "Rieti (RI)" },
    { value: "Rimini (RN)", label: "Rimini (RN)" },
    { value: "Roma (Roma)", label: "Roma (Roma)" },
    { value: "Rovigo (RO)", label: "Rovigo (RO)" },
    { value: "Salerno (SA)", label: "Salerno (SA)" },
    { value: "Sassari (SS)", label: "Sassari (SS)" },
    { value: "Savona (SV)", label: "Savona (SV)" },
    { value: "Siena (SI)", label: "Siena (SI)" },
    { value: "Siracusa (SR)", label: "Siracusa (SR)" },
    { value: "Sondrio (SO)", label: "Sondrio (SO)" },
    { value: "Taranto (TA)", label: "Taranto (TA)" },
    { value: "Teramo (TE)", label: "Teramo (TE)" },
    { value: "Terni (TR)", label: "Terni (TR)" },
    { value: "Torino (TO)", label: "Torino (TO)" },
    { value: "Trapani (TP)", label: "Trapani (TP)" },
    { value: "Trento (TN)", label: "Trento (TN)" },
    { value: "Treviso (TV)", label: "Treviso (TV)" },
    { value: "Trieste (TS)", label: "Trieste (TS)" },
    { value: "Udine (UD)", label: "Udine (UD)" },
    { value: "Varese (VA)", label: "Varese (VA)" },
    { value: "Venezia (VE)", label: "Venezia (VE)" },
    { value: "Verbania (VB)", label: "Verbania (VB)" },
    { value: "Vercelli (VC)", label: "Vercelli (VC)" },
    { value: "Verona (VR)", label: "Verona (VR)" },
    { value: "Vibo-Valentia (VV)", label: "Vibo-Valentia (VV)" },
    { value: "Vicenza (VI)", label: "Vicenza (VI)" },
    { value: "Viterbo (VT)", label: "Viterbo (VT)" },
  ];

  export default provinces;